const creatorData = [
    {
        id: 1,
        img: 'assets/images/nft/group-01.jpg',
        title: "Apollo Group",
        price: "4 members",
    },
    {
        id: 2,
        img: 'assets/images/nft/group-02.jpg',
        title: "Penasu Group",
        price: "2 members",
    },
    {
        id: 3,
        img: 'assets/images/nft/group-03.jpg',
        title: "Ulu Sungai Merah Group",
        price: "2 members",
    },
];

export { creatorData };
